// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isTemplate = function (this: any) {
  return this.templateFlagEnabled && this.model.isTemplate();
};
